/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
import { BookingAssetInfoFromJSON, BookingAssetInfoFromJSONTyped, BookingAssetInfoToJSON, BookingAssetInfoToJSONTyped, } from './BookingAssetInfo';
/**
 * @export
 */
export const BookingStatusEnum = {
    Planned: 'planned',
    Live: 'live',
    Finished: 'finished',
    Aborted: 'aborted',
    Paused: 'paused',
    Canceled: 'canceled',
    Rejected: 'rejected',
    Draft: 'draft',
    Requested: 'requested'
};
/**
 * Check if a given object implements the Booking interface.
 */
export function instanceOfBooking(value) {
    if ((!('name' in value) && !('Name' in value)) || (value['name'] === undefined && value['Name'] === undefined))
        return false;
    if ((!('refBrand' in value) && !('RefBrand' in value)) || (value['refBrand'] === undefined && value['RefBrand'] === undefined))
        return false;
    if ((!('refAdvertiser' in value) && !('RefAdvertiser' in value)) || (value['refAdvertiser'] === undefined && value['RefAdvertiser'] === undefined))
        return false;
    if ((!('budgetTotal' in value) && !('BudgetTotal' in value)) || (value['budgetTotal'] === undefined && value['BudgetTotal'] === undefined))
        return false;
    return true;
}
export function BookingFromJSON(json) {
    return BookingFromJSONTyped(json, false);
}
export function BookingFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['Id'] == null ? undefined : json['Id'],
        'name': json['Name'],
        'refSlot': json['RefSlot'] == null ? undefined : json['RefSlot'],
        'refBrand': json['RefBrand'],
        'refAdvertiser': json['RefAdvertiser'],
        'budgetTotal': json['BudgetTotal'],
        'start': json['Start'] === undefined ? undefined : json['Start'] === null ? null : (new Date(json['Start'])),
        'end': json['End'] === undefined ? undefined : json['End'] === null ? null : (new Date(json['End'])),
        'budgetSpent': json['BudgetSpent'] == null ? undefined : json['BudgetSpent'],
        'status': json['Status'] == null ? undefined : json['Status'],
        'assets': json['Assets'] == null ? undefined : (json['Assets'].map(BookingAssetInfoFromJSON)),
    };
}
export function BookingToJSON(json) {
    return BookingToJSONTyped(json, false);
}
export function BookingToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Id': value['id'],
        'Name': value['name'],
        'RefSlot': value['refSlot'],
        'RefBrand': value['refBrand'],
        'RefAdvertiser': value['refAdvertiser'],
        'BudgetTotal': value['budgetTotal'],
        'Start': value['start'] == null ? value['start'] : value['start'].toISOString(),
        'End': value['end'] == null ? value['end'] : value['end'].toISOString(),
        'BudgetSpent': value['budgetSpent'],
        'Status': value['status'],
        'Assets': value['assets'] == null ? undefined : (value['assets'].map(BookingAssetInfoToJSON)),
    };
}
